import './share'
import './sharetabview'
import './sharebreadcrumbview'

import './style/sharetabview.scss'
import './style/sharebreadcrumb.scss'
